export const DATE_FORMAT = {
    TIME: ' HH[h]mm',
};